import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountCreationModalComponent } from './discount-creation-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [DiscountCreationModalComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    CurrencyMaskModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
})
export class DiscountCreationModalModule { }
